import { render, staticRenderFns } from "./roleList.vue?vue&type=template&id=2d0dcf7f&scoped=true&"
import script from "./roleList.vue?vue&type=script&lang=js&"
export * from "./roleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0dcf7f",
  null
  
)

export default component.exports